import { useFindAllSoftwareQuery } from "../api/api-hooks";

export const useSoftwareTypeMap = () => {
  const { data: types } = useFindAllSoftwareQuery({});
  const typeMap = new Map<number, string>();
  if (types === undefined) return typeMap;
  for (const type of types) {
    typeMap.set(type.id, type.type);
  }
  return typeMap;
};
